import {
  FileSearch,
  Globe,
  HelpCircle,
  LayoutDashboard,
  QrCode,
  Settings,
  Sparkles,
  Zap,
} from 'lucide-react'
import { ROUTES } from '@/utils/constants'
import type { LucideIcon } from 'lucide-react'

export interface NavItem {
  label: string
  path: string
  icon: LucideIcon
  badge?: string
}

export const navItems: NavItem[] = [
  { label: 'Dashboard', path: ROUTES.DASHBOARD, icon: LayoutDashboard },
  {
    label: 'Digital QR',
    path: ROUTES.DIGITAL_QR,
    icon: QrCode,
    badge: 'NEW',
  },
  {
    label: 'Google Automation',
    path: ROUTES.GOOGLE_AUTOMATION,
    icon: Zap,
  },
  {
    label: 'Google Audit Report',
    path: ROUTES.GOOGLE_AUDIT,
    icon: FileSearch,
  },
  {
    label: 'AI Suggested Posts',
    path: ROUTES.AI_POSTS,
    icon: Sparkles,
  },
  { label: 'Website', path: ROUTES.WEBSITE, icon: Globe },
  { label: 'Need Help?', path: ROUTES.NEED_HELP, icon: HelpCircle },
  { label: 'Settings', path: ROUTES.SETTINGS, icon: Settings },
]

export const breadcrumbLabels: Record<string, string> = {
  [ROUTES.DASHBOARD]: 'Dashboard',
  [ROUTES.DIGITAL_QR]: 'Digital QR',
  [ROUTES.GOOGLE_AUTOMATION]: 'Google Business',
  [ROUTES.GOOGLE_AUDIT]: 'GMB Audit Report',
  [ROUTES.AI_POSTS]: 'Generate Posts',
  [ROUTES.WEBSITE]: 'Website',
  [ROUTES.NEED_HELP]: 'Plans',
  [ROUTES.SETTINGS]: 'Settings',
}
